/**
 * @generated SignedSource<<c05873e591ce97d354b409a646b04334>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type FeatureKey = "ADDITIONAL_LISTS" | "BIOMETRIC_LOCK" | "BUDGET" | "ESTATE_SEARCH" | "EXTENDED_ADDRESS_LOOKUP" | "FLOOD_MAP" | "HOME_FEED" | "HOME_OWNERSHIP" | "HOME_RECORDS" | "HOME_UPDATES" | "HOME_UPDATES_PUSH_ANNIVERSARY" | "HOME_UPDATES_PUSH_FLOOD" | "HOME_UPDATES_PUSH_HOME_VALUE" | "HOME_UPDATES_PUSH_PLANNING" | "HOME_UPDATES_PUSH_RATE_DECISION" | "HOME_UPDATES_PUSH_RENT_CHECK" | "HOME_UPDATES_PUSH_SOLD_NEAR_YOU" | "HOUSEHOLD_MONEY" | "JOURNEY_NUDGES" | "LISTING_PHOTO_IMPORT" | "LOCAL_KNOWLEDGE" | "NOISE_INSIGHT" | "PERSONA_JOURNEYS" | "REACHABLE_AREA_SCENE" | "REALTIME_PRESENCE" | "REAL_JOURNEY_TIMES" | "REMOTE_FETCH_IMPORT" | "VIEWINGS" | "VIEWING_NOTE_SUGGESTIONS" | "VOICE" | "%future added value";
export type PlanBucket = "COMPLIMENTARY" | "FREE" | "PAYING" | "%future added value";
export type vaultDetailQuery$variables = {
  vaultId: any;
};
export type vaultDetailQuery$data = {
  readonly featureFlags: ReadonlyArray<{
    readonly key: FeatureKey;
  }>;
  readonly vaultDetail: {
    readonly canGrant: boolean;
    readonly complimentary: {
      readonly complimentaryUntil: any | null | undefined;
      readonly isComplimentary: boolean;
      readonly lastGrant: {
        readonly occurredUtc: any;
        readonly operator: string;
        readonly reason: string;
        readonly term: string | null | undefined;
      } | null | undefined;
      readonly lastRevoke: {
        readonly occurredUtc: any;
        readonly operator: string;
        readonly reason: string;
        readonly term: string | null | undefined;
      } | null | undefined;
      readonly revokedEarly: boolean;
    };
    readonly createdUtc: any;
    readonly identifier: string;
    readonly jurisdiction: string;
    readonly members: ReadonlyArray<{
      readonly accountId: any;
      readonly email: string | null | undefined;
      readonly joinedUtc: any;
      readonly lastLoginUtc: any | null | undefined;
      readonly roleName: string;
    }>;
    readonly name: string;
    readonly overrides: ReadonlyArray<{
      readonly flagKey: string;
      readonly state: string;
    }>;
    readonly planBucket: PlanBucket;
    readonly planName: string | null | undefined;
    readonly ring: string;
    readonly subscriptionStatus: string | null | undefined;
    readonly vaultId: any;
  } | null | undefined;
};
export type vaultDetailQuery = {
  response: vaultDetailQuery$data;
  variables: vaultDetailQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "vaultId"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "operator",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "term",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "reason",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "occurredUtc",
    "storageKey": null
  }
],
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "vaultId",
        "variableName": "vaultId"
      }
    ],
    "concreteType": "VaultDetail",
    "kind": "LinkedField",
    "name": "vaultDetail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vaultId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "identifier",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "jurisdiction",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ring",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "createdUtc",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "planName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "subscriptionStatus",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "planBucket",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "canGrant",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VaultComplimentaryStanding",
        "kind": "LinkedField",
        "name": "complimentary",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isComplimentary",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "complimentaryUntil",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VaultGrantAction",
            "kind": "LinkedField",
            "name": "lastGrant",
            "plural": false,
            "selections": (v1/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "VaultGrantAction",
            "kind": "LinkedField",
            "name": "lastRevoke",
            "plural": false,
            "selections": (v1/*: any*/),
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "revokedEarly",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VaultMemberDetail",
        "kind": "LinkedField",
        "name": "members",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "roleName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "joinedUtc",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastLoginUtc",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "VaultFeatureOverride",
        "kind": "LinkedField",
        "name": "overrides",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "flagKey",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "FeatureFlagState",
    "kind": "LinkedField",
    "name": "featureFlags",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "vaultDetailQuery",
    "selections": (v2/*: any*/),
    "type": "AdminQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "vaultDetailQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "c699a1e69f04cc521c8ad7aa68a50cc2",
    "id": null,
    "metadata": {},
    "name": "vaultDetailQuery",
    "operationKind": "query",
    "text": "query vaultDetailQuery(\n  $vaultId: UUID!\n) {\n  vaultDetail(vaultId: $vaultId) {\n    vaultId\n    name\n    identifier\n    jurisdiction\n    ring\n    createdUtc\n    planName\n    subscriptionStatus\n    planBucket\n    canGrant\n    complimentary {\n      isComplimentary\n      complimentaryUntil\n      lastGrant {\n        operator\n        term\n        reason\n        occurredUtc\n      }\n      lastRevoke {\n        operator\n        term\n        reason\n        occurredUtc\n      }\n      revokedEarly\n    }\n    members {\n      accountId\n      email\n      roleName\n      joinedUtc\n      lastLoginUtc\n    }\n    overrides {\n      flagKey\n      state\n    }\n  }\n  featureFlags {\n    key\n  }\n}\n"
  }
};
})();

(node as any).hash = "10f0d85a40dec0bcc1cfb1f9e20c7cf1";

export default node;
